import "./App.css";
import React, { useState, useEffect } from "react";
import "./i18n"; // Make sure to import this to initialize the i18n instance
import { ThemeProvider, createTheme } from "@mui/material";
import { CssBaseline } from "@mui/material";
import { lightTheme, darkTheme } from "./theme";
import { Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./Screens/Error/ErrorBoundary";
import { routes } from "./Routes";
import Loading from "./Controller/LoadingController/Loading";
import AppColors from "./Utils/AppColor";
import AgriDashboardLayout from "./Screens/AgriDashboardLayout/AgriDashboardLayout";
import { MasterContext } from "./ContextAPI/MasterContext";
import MainLayout from "./Controller/LayoutController/MainLayout";
import { WasteManagementContext } from "./ContextAPI/WasteManagementContext";
import Toastbox from "./CommonComponents/ToastBox";
import LoginPage from "./Screens/Login/Login";
import PrivateRoute from "./Routes/PrivateRoute";
import { InfrastructureContext } from "./ContextAPI/InfrastructureContext";
import { AgricultureContext } from "./ContextAPI/AgricultureContext";
import { CtmLiveOverViewContext } from "./ContextAPI/CtmLiveOverViewContext";
import { RetailContext } from "./ContextAPI/RetailContext";
import FeedBackChat from "./Assistance/ChatGptFeedbackPrompt";
import SensorBot from "./Assistance/ChatGptSensorPrompt";

function PageNotFound() {
  return (
    <div>
      <h2>404 Page not found</h2>
    </div>
  );
}

function App() {
  const [light, setLight] = useState(true);
  return (
    <React.Fragment>
      <CssBaseline enableColorScheme={true} />
      <ThemeProvider theme={light ? lightTheme : darkTheme}>
        <MasterContext>
          <RetailContext>
            <AgricultureContext>
              <WasteManagementContext>
                <InfrastructureContext>
                  <CtmLiveOverViewContext>
                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                      <Routes>
                        {/* <Route path="/" element={<LoginPage />}></Route> */}
                        <Route path="/" element={<SensorBot />} />
                        <Route
                          path="/"
                          element={
                            <React.Suspense
                              fallback={
                                <div
                                  style={{
                                    background: AppColors.mainBg,
                                    height: `100vh`,
                                  }}
                                >
                                  <Loading
                                    loading={true}
                                    type={`dots`}
                                    backDrop={false}
                                  />
                                </div>
                              }
                            >
                              <PrivateRoute>
                                <MainLayout />
                              </PrivateRoute>
                            </React.Suspense>
                          }
                        >
                          {routes}
                        </Route>
                        <Route path="*" element={<PageNotFound />} />
                      </Routes>
                    </ErrorBoundary>
                    <Toastbox />
                  </CtmLiveOverViewContext>
                </InfrastructureContext>
              </WasteManagementContext>
            </AgricultureContext>
          </RetailContext>
        </MasterContext>
      </ThemeProvider>
    </React.Fragment>
  );
}

export default App;
